import { useMemo } from 'react';

import { filterModuleProperties } from '../filterModuleUtils';

import {
  checkEmptyDataProductModule,
  lowercaseProductData,
  mappingDataProductByFieldFullPath,
} from '../utils';

export const useGetProductOverlayInfo = ({
  dataProductOverlayModule,
  dataOriginalProductModule,
  moduleProduct,
}) => {
  const filteredModuleProduct = useMemo(
    () => filterModuleProperties(moduleProduct),
    [moduleProduct]
  );

  const { moduleProperties } = filteredModuleProduct;

  // Overlay
  const { data: dataProductOverlay } = dataProductOverlayModule;

  const overlayFormattedData = useMemo(
    () =>
      mappingDataProductByFieldFullPath(
        lowercaseProductData(dataProductOverlay),
        moduleProperties
      ),
    [dataProductOverlay, moduleProperties]
  );

  // Origin
  const { data: dataOriginalProduct } = dataOriginalProductModule;

  const originalFormattedData = useMemo(
    () =>
      mappingDataProductByFieldFullPath(
        lowercaseProductData(dataOriginalProduct),
        moduleProperties
      ),
    [dataOriginalProduct, moduleProperties]
  );

  const isEmptyData = checkEmptyDataProductModule(dataProductOverlay);

  return {
    isEmptyData,
    filteredModuleProduct,
    overlayFormattedData,
    originalFormattedData,
  };
};
